export const appConfiguration = {
  clientId: '3c0d63b3-c2f9-4e4b-b0e8-b8fd0fa39e01',
  authority:
    'https://login.microsoftonline.com/2ef09b02-2e8f-4181-8bb2-78cfc813799a',
};
